import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
const comparisons = [{
  without: '120 hs/año planificando desde cero',
  withPack: '10 min/semana. El resto es enseñar.'
}, {
  without: 'Correcciones improvisadas → mismo error por meses',
  withPack: '80+ guiones exactos → se resuelve en la clase'
}, {
  without: '70% de abandono antes del año',
  withPack: 'Sistema de 4 Pilares → retención +85%'
}, {
  without: 'Sin material diferenciado por nivel',
  withPack: '6 tomos con progresión → avanzan y recomiendan'
}];
export function FinalCTA() {
  return <section className="w-full bg-[#111111] py-16 sm:py-24 px-4 overflow-hidden" data-id="element-82">
      <div className="max-w-2xl mx-auto text-center relative" data-id="element-83">
        {/* Ambient glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#C8962E]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-84" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="relative z-10" data-id="element-85">
          <div className="text-[#C8962E]/70 text-xs font-bold tracking-[0.3em] uppercase mb-6" data-id="element-86">
            💃 PROFEPACK™
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 leading-tight" data-id="element-87">
            El próximo domingo podés seguir buscando en internet.
          </h2>
          <p className="text-[#C8962E] text-2xl sm:text-3xl md:text-4xl font-black mb-10 leading-tight" data-id="element-88">
            O podés tener todo resuelto desde hoy.
          </p>

          {/* Compact Cost Table */}
          <div className="bg-white/[0.02] border border-[#C8962E]/20 rounded-2xl overflow-hidden mb-12 shadow-xl text-left" data-id="element-89">
            <div className="p-3 sm:p-4 bg-black/60 border-b border-[#C8962E]/30 text-center font-bold text-white text-xs sm:text-sm" data-id="element-90">
              ¿Cuánto cuesta NO tenerlo?
            </div>
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-1 sm:grid-cols-2 border-b border-white/5 last:border-b-0" data-id="element-91">
                <div className="p-3 sm:p-4 text-gray-400 text-xs sm:text-sm flex items-center" data-id="element-92">
                  ❌ {row.without}
                </div>
                <div className="p-3 sm:p-4 text-white font-bold text-xs sm:text-sm bg-[#C8962E]/[0.03] sm:border-l border-white/5 flex items-center" data-id="element-93">
                  ✅ {row.withPack}
                </div>
              </div>)}
          </div>

          {/* Countdown */}
          <div className="mb-6" data-id="element-94">
            <p className="text-white font-bold text-sm sm:text-base mb-4" data-id="element-95">
              ⏰ El precio de lanzamiento cierra en:
            </p>
            <CountdownTimer size="lg" blinking={true} data-id="element-96" />
          </div>
          <p className="text-gray-400 text-xs sm:text-sm mb-10" data-id="element-97">
            Después sube{' '}
            <span className="text-red-500 font-bold" data-id="element-98">$8.000 ARS</span> y no
            vuelve.
          </p>

          {/* 2 mini pricing cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 mb-10" data-id="element-99">
            <motion.div whileHover={{
            y: -4
          }} className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-5 sm:p-6 text-center flex flex-col transition-colors hover:border-white/20" data-id="element-100">
              <div className="text-2xl mb-2" data-id="element-101">📘</div>
              <h3 className="text-white font-black text-sm sm:text-base mb-1" data-id="element-102">
                MEGAPACK TANGO LISTO
              </h3>
              <p className="text-gray-400 text-[11px] sm:text-xs mb-5" data-id="element-103">
                6 Tomos + 6 Bonos
              </p>
              <div className="mt-auto" data-id="element-104">
                <p className="text-white text-2xl sm:text-3xl font-black mb-4" data-id="element-105">
                  $19.990 ARS
                </p>
                <motion.a href="https://www.profepack.com/cart/48163872211200:1" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="btn-green-pulse block bg-[#C8962E] text-black font-black py-3.5 sm:py-4 rounded-xl hover:bg-[#D9A840] transition-colors text-xs sm:text-sm shadow-lg" data-id="element-106">
                  → QUIERO MI MEGAPACK
                </motion.a>
              </div>
            </motion.div>

            <motion.div whileHover={{
            y: -4
          }} className="relative bg-[#1a1500] border-2 border-[#C8962E] rounded-2xl p-5 sm:p-6 text-center shadow-[0_0_30px_rgba(200,150,46,0.15)] flex flex-col" data-id="element-107">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#C8962E] to-[#eab308] text-black text-[9px] sm:text-[10px] font-black px-3 py-0.5 rounded-full whitespace-nowrap" data-id="element-108">
                ⭐ MÁS ELEGIDO
              </div>
              <div className="text-2xl mb-2 mt-1" data-id="element-109">🏆</div>
              <h3 className="text-[#C8962E] font-black text-sm sm:text-base mb-1 leading-tight" data-id="element-110">
                MEGAPACK + ECOSISTEMA
              </h3>
              <p className="text-gray-400 text-[11px] sm:text-xs mb-5 leading-tight" data-id="element-111">
                6 Tomos + 6 Bonos + Ecosistema del Alumno Pro™
              </p>
              <div className="mt-auto" data-id="element-112">
                <p className="text-[#C8962E] text-2xl sm:text-3xl font-black mb-4" data-id="element-113">
                  $27.990 ARS
                </p>
                <motion.a href="https://www.profepack.com/cart/48163895509248:1" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="btn-green-pulse green-shimmer block bg-[#C8962E] text-black font-black py-3.5 sm:py-4 rounded-xl hover:bg-[#D9A840] transition-colors text-xs sm:text-sm shadow-[0_0_20px_rgba(200,150,46,0.3)]" data-id="element-114">
                  → QUIERO EL ECOSISTEMA
                </motion.a>
              </div>
            </motion.div>
          </div>

          {/* Final trust bar */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mt-8" data-id="element-115">
            {[{
            icon: '🔒',
            text: 'Pago 100% seguro'
          }, {
            icon: '⚡',
            text: 'Acceso en 5 min'
          }, {
            icon: '🛡️',
            text: 'Garantía 7 días'
          }, {
            icon: '💳',
            text: 'Mercado Pago | Tarjetas | Transferencia'
          }].map((badge, i) => <div key={i} className="flex items-center gap-1.5 bg-white/[0.03] border border-white/[0.05] rounded-lg px-3 py-2" data-id="element-116">
                <span className="text-sm" data-id="element-117">{badge.icon}</span>
                <span className="text-gray-300 text-[10px] sm:text-xs font-medium" data-id="element-118">
                  {badge.text}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}